import React from 'react'
import { Styles } from './src/parsley-core/theme/index'

export const wrapPageElement = ({ element }) => {
    return <>
        <Styles />
        {element}
    </>
}
